export default function contentSquare() {
    $(document).ready(function() {
        $('#customer_details_form_dateOfBirth').attr('data-cs-mask', '');
        $('#customer_details_form_title').attr('data-cs-mask', '');
        $('#customer_form_address').attr('data-cs-mask', '');
        $('#customer_form_title').attr('data-cs-mask', '');
        $('#form_name_title').attr('data-cs-mask', '');
        $('#form_bank_timeWithBank').attr('data-cs-mask', '');
    });
}
